// Firebase configuration for frontend
// TODO: Replace with your actual Firebase project configuration
// Get this from Firebase Console > Project Settings > General > Your apps > Web app

const firebaseConfig = {
  // You need to get these values from Firebase Console
  apiKey: "AIzaSyBPJ6J9Z5GCi4xtdkUPuR-n35shj0nc5-E",
  authDomain: "almacen-infra-470008.firebaseapp.com",
  projectId: "almacen-infra-470008",
  storageBucket: "almacen-infra-470008.firebasestorage.app",
  messagingSenderId: "88876116330",
  appId: "1:88876116330:web:d51503ecd18886c5971d13"
};

export default firebaseConfig;

// Instructions to get Firebase config:
// 1. Go to Firebase Console: https://console.firebase.google.com/
// 2. Create new project or use existing one
// 3. Go to Project Settings > General
// 4. Scroll down to "Your apps" section
// 5. Click "Add app" and select web app (</>) 
// 6. Copy the config object and replace the values above
// 7. Enable Authentication > Sign-in method > Google
